import type { FC } from "react";
import styles from "@/layouts/AppLayout/EmptyState.module.css";

interface EmptyStateProps {
  title: string;
  hint?: string;
}

const EmptyState: FC<EmptyStateProps> = ({ title, hint }) => (
  <div className={styles.emptyState}>
    <svg
      className={styles.icon}
      fill="none"
      height="20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="20"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" x2="12" y1="8" y2="12" />
      <line x1="12" x2="12.01" y1="16" y2="16" />
    </svg>
    <p className={styles.title}>{title}</p>
    {hint && <p className={styles.hint}>{hint}</p>}
  </div>
);

export default EmptyState;
